import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {Site} from '../../shared/models/site';
import {LoadSitesSelectedSuccessAction, sitesSelectedActionTypes} from '../actions/sites-selected-load';

export interface SiteSelectedState {
  sitesSelected: Site[];
}

const initialState: SiteSelectedState = {
  sitesSelected: undefined
};

export function SitesSelectedReducer(state: SiteSelectedState = initialState, action: Action): SiteSelectedState {
  switch (action.type) {
    case sitesSelectedActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case sitesSelectedActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case sitesSelectedActionTypes.CLEAR:
      return handleLoadClearActions();
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: SiteSelectedState, action: LoadSitesSelectedSuccessAction): SiteSelectedState {
  const newState: SiteSelectedState = {
    sitesSelected: action.payload
  };
  return newState;
}

function handleLoadClearActions(): SiteSelectedState {
  const newState: SiteSelectedState = {
    sitesSelected: []
  };
  return newState;
}

function handleLoadErrorActions(state: SiteSelectedState): SiteSelectedState {
  return state;
}

export const sitesSelectedSelectors = {
  sitesSelected: (state: SiteSelectedState) => _.get(state, 'sitesSelected.array', null)
};
